module.exports = __webpack_public_path__ + "img/road.6b0c9ade.png";